import React, { Component } from "react";
import CountUp from "react-countup";
import Fade from "react-reveal/Fade";
import TrackVisibility from "react-on-screen";

import SectionTitle from "../SectionTitle/SectionTitle";
import "./Accomplishments.css";

const counters = [
  {
    title: "متدرب ومتدربة",
    start: 0,
    end: 50000
  },
  {
    title: "مدينة ومحافظة حول المملكة",
    start: 0,
    end: 52
  },
  {
    title: "متدرب ومتدربة من مختصي تقنية المعلومات",
    start: 0,
    end: 1300
  },
  {
    title: "متدرب ومتدربة من صناع القرار في الجهات الحكومية",
    start: 0,
    end: 120
  }
];

export default class Accomplishments extends Component {
  render() {
    return (
      <section id="accomplishments" className="section">
        <Fade duration={1000} delay={200}>
          <SectionTitle color={"#fff"}>إنجازات الأكاديمية </SectionTitle>
        </Fade>

        <div className="columns mt-4">
          <Fade duration={1000} delay={200}>
            <div className="column is-12 has-text-centered">
              <h3 className="is-size-3 is-white">
                إدارة التطوير وعمليات التعليم
              </h3>
            </div>
          </Fade>
        </div>

        <div className="columns is-gapless has-text-centered counters">
          {counters.map((counter, i) => {
            return (
              <Fade duration={1000} delay={200} key={i}>
                <div className="column is-3">
                  <div className="counter">
                    <TrackVisibility once>
                      {({ isVisible }) =>
                        isVisible && (
                          <CountUp
                            start={counter.start}
                            end={counter.end}
                            duration={5}
                            separator=","
                          />
                        )
                      }

                      {/* <span id="countTrainer" data-count="50000">0</span> */}
                    </TrackVisibility>
                  </div>
                  <p className="mt-1">{counter.title}</p>
                </div>
              </Fade>
            );
          })}
        </div>
      </section>
    );
  }
}
